import Action from '@components/Action'
import AddIcon from '@components/Icon/AddExpert'
import Delete from '@components/Icon/Delete'
import Edit from '@components/Icon/Edit'
import EmployeeCard from './EmployeeCard'
import ListEmployees from './ListEmployees'
import React from 'react'
import Star from '@components/Icon/Star'
import propTypes from 'prop-types'
import { Link } from 'react-router-dom'

const ListPrincipal = ({ id, name = '', label = 'Principal' }) => id ? (
	<div className="team__principal-wrapper">
		<span className="text-gray">{label}: </span>
		<Link to={'/employee/' + id}>{name}</Link>
	</div>
) : null

const TeamActions = ({ store, growlStore, editTeam, removeTeam, team, addEmployee }) => store.isEditable && (
	<div className="actions-wrapper">
		<ul className="actions">
			<li className="action">
				<Action
					onClick={async () => {
						const newTarget = prompt(
							'Please enter new global target for the team'
						)
						const employees = store.employees.filter(
							e => e.teamId === team.id
						)
						for (const employee of employees) {
							employee.targetMargin = newTarget

							const res = await store.updateEmployeeTargetMargin({
								employeeId: employee.id,
								targetMargin: newTarget
							})
							employee.targetMargin = res.targetMargin.toFixed(2)
						}
						growlStore.showSuccess(
							`All team member targets have been updated to EUR ${employees[0].targetMargin}`
						)
					}}>
					<Star />
					Set Target
				</Action>
				{team.accountManager && (
					<Action
						onClick={() =>
							addEmployee(team.id, team.accountManager.id, true, true)
						}>
						<AddIcon />
						Add Team Leader
					</Action>
				)}
			</li>
			<li className="action">
				<Action onClick={() => editTeam(team)}>
					<Edit />
					Edit
				</Action>
			</li>
			<li className="action">
				<Action onClick={() => removeTeam(team.id)}>
					<Delete />
					Delete
				</Action>
			</li>
		</ul>
	</div>
)

const ListTeamLeadAndMembers = ({ teamLead, store, removeEmployee, team, addEmployee }) => {
	const [subordinate] = store
		.getTeamLeadersBySupervisor(
			teamLead.id
		)


	if (teamLead.isSenior) {
		return (<div key={teamLead.id}>
			<div>
				<EmployeeCard
					store={store}
					employee={teamLead}
					removeEmployee={removeEmployee}
				/>

				{subordinate ? ListTeamLeadAndMembers({ teamLead: subordinate, store, removeEmployee, team, addEmployee }) : (

					<div className="actions-wrapper left-text">
						<ul className="actions">
							<li className="action">
								<Action
									onClick={() =>
										addEmployee(team.id, teamLead.id, true, false)
									}>
									<AddIcon />
									Add Team Leader
								</Action>
							</li>
						</ul>
					</div>
				)}
			</div>
		</div>
		)
	} else {

		return (
			<div key={teamLead.id}>
				<div>
					<EmployeeCard
						store={store}
						employee={teamLead}
						removeEmployee={removeEmployee}
					/>
				</div>
				<ListEmployees
					store={store}
					removeEmployee={removeEmployee}
					employees={store.getAssociatesBySupervisor(teamLead.id)}
				/>
				{store.isEditable && (
					<AddAssociate
						teamId={team.id}
						supervisorId={teamLead.id}
						addEmployee={addEmployee}
					/>
				)}
			</div>
		)
	}
}

const ListTeam = ({
	team,
	store,
	addEmployee,
	growlStore,
	removeEmployee,
	editTeam,
	removeTeam
}) => {
	return (
		<div className="team--team-card" id={team.name.replace(/\s/g, '-')}>
			<div className="team--header" id={`scroll-anchor-${team.id}`}>
				<div style={{ width: '100%' }}>
					<h2>{team.name}</h2>
					<ListPrincipal id={team.accountManager?.seniorPrincipalId} name={team.accountManager?.seniorPrincipalName} label="Senior Principal" />
					<ListPrincipal id={team.accountManager?.principalId} name={team.accountManager?.principalName} />
				</div>
				<TeamActions addEmployee={addEmployee} team={team} store={store} editTeam={editTeam} growlStore={growlStore} removeTeam={removeTeam} />
			</div>
			<div className="team--employees">
				<div>
					{team.accountManager?.supervisorId && (<EmployeeCard store={store} employee={store.employees.find(e => e.id === team.accountManager.supervisorId)} />)}
					<EmployeeCard store={store} employee={team.accountManager} />
					<ListEmployees
						store={store}
						removeEmployee={removeEmployee}
						employees={store.getAssociatesBySupervisor(
							team.accountManager ? team.accountManager.id : 0
						)}
					/>
					{store.isEditable && team.accountManager && (
						<AddAssociate
							teamId={team.id}
							supervisorId={team.accountManager.id}
							addEmployee={addEmployee}
						/>
					)}
				</div>
				{
					store
						.getTeamLeadersBySupervisor(
							team.accountManager ? team.accountManager.id : 0
						)
						.map(teamLead => ListTeamLeadAndMembers({ teamLead, store, removeEmployee, team, addEmployee }))}
			</div>
		</div>
	)
}
ListTeam.propTypes = {
	team: propTypes.object.isRequired,
	accountManager: propTypes.object.isRequired,
	growlStore: propTypes.object.isRequired,
	store: propTypes.object.isRequired,
	addEmployee: propTypes.func.isRequired,
	editTeam: propTypes.func.isRequired,
	removeTeam: propTypes.func.isRequired,
	removeEmployee: propTypes.func.isRequired
}

const AddAssociate = ({ addEmployee, teamId, supervisorId }) => (
	<div className="actions-wrapper left-text">
		<ul className="actions">
			<li className="action">
				<Action
					className="primary"
					onClick={() => addEmployee(teamId, supervisorId)}>
					<AddIcon />
					Add Associate
				</Action>
			</li>
		</ul>
	</div>
)
AddAssociate.propTypes = {
	teamId: propTypes.number.isRequired,
	supervisorId: propTypes.number.isRequired,
	addEmployee: propTypes.func.isRequired
}

export default ListTeam
